// Per-property stats — file and comment counts plus "new since last view"
// deltas against a baseline snapshot. Pure module: no DOM, no Firestore.
//
// Baseline shape (persisted to localStorage by the dashboard):
//   { files: {pid: [file ids]}, notes: {pid: [note ids]} }
// Anything in the current view not in the baseline counts as new.
export function fileId(f) {
  return f.id || f.name || f.path || '';
}

/** Counts for one property row. `noteIds` = live Set of comment ids on the
 * property's thread (null when there's no data yet). */
export function propertyStats(p, noteIds, baseline) {
  const files = (p.files || []).map(fileId).filter(Boolean);
  const newFiles = files.filter((id) => !(baseline.files?.[p.id] || []).includes(id)).length;
  const comments = noteIds ? [...noteIds] : [];
  const newComments = comments.filter((id) => !(baseline.notes?.[p.id] || []).includes(id)).length;
  return { files: files.length, newFiles, comments: comments.length, newComments };
}
